import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const KeyboardBackspace = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 26H11.444C10.017 26 8.655 25.388 7.707 24.322L3.263 19.322C2.449 18.406 2 17.226 2 16C2 14.774 2.449 13.595 3.263 12.678L7.707 7.678C8.655 6.612 10.017 6 11.444 6H25C27.757 6 30 8.243 30 11V21C30 23.757 27.757 26 25 26ZM11.444 8C10.588 8 9.77 8.367 9.202 9.007L4.758 14.007C4.269 14.557 4 15.265 4 16C4 16.735 4.269 17.443 4.758 17.993L9.202 22.993C9.771 23.633 10.588 24 11.444 24H25C26.654 24 28 22.654 28 21V11C28 9.346 26.654 8 25 8H11.444Z" />
		<path d="M19.414 16L21.707 13.707C21.888 13.526 22 13.276 22 13C22 12.448 21.552 12 21 12C20.724 12 20.474 12.112 20.293 12.293L18 14.586L15.707 12.293C15.526 12.112 15.276 12 15 12C14.448 12 14 12.448 14 13C14 13.276 14.112 13.526 14.293 13.707L16.586 16L14.293 18.293C14.112 18.474 14 18.724 14 19C14 19.552 14.448 20 15 20C15.276 20 15.526 19.888 15.707 19.707L18 17.414L20.293 19.707C20.474 19.888 20.724 20 21 20C21.552 20 22 19.552 22 19C22 18.724 21.888 18.474 21.707 18.293L19.414 16Z" />
	</svg>
);

export default KeyboardBackspace;
